export default "__VITE_ASSET__BWLBi8mi__"